import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-spinkit';
import GoogleMapComponent from '../components/googleMap/';
import { brandColor } from '../utils/styleConst';
import './App.css';

const App = ({ studios, isLoading }) => (
  isLoading ?
    <Spinner name="folding-cube" color={brandColor} className="spinner" />
    :
    <GoogleMapComponent studioData={studios} isMarkerShown />
);

App.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  studios: PropTypes.arrayOf(PropTypes.object).isRequired,
};


export default App;



// WEBPACK FOOTER //
// src/App/App.jsx